import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";

import { useEffect } from "react";

import { useTranslation } from "react-i18next";
import { useConfirm } from "./useConfirm";

const ConfirmModal = () => {
  const { t } = useTranslation();
  const { prompt = t("general.are_you_sure"), body = null, isOpen = false, proceed, cancel } = useConfirm();

  useEffect(() => {
    const handleKeydown = (e: KeyboardEvent) => {
      if (proceed && isOpen && e.key === "Enter") {
        proceed();
      }
    };

    window.addEventListener("keydown", handleKeydown);
    return () => window.removeEventListener("keydown", handleKeydown);
  }, [proceed, isOpen]);

  return (
    <Dialog
      open={isOpen}
      onClose={() => cancel?.()}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{ minWidth: "400px" }}
    >
      <DialogTitle id="alert-dialog-title" sx={{ minWidth: "400px" }}>
        {prompt}
      </DialogTitle>
      {body && (
        <DialogContent>
          <DialogContentText id="alert-dialog-description">{body}</DialogContentText>
        </DialogContent>
      )}
      <DialogActions>
        <Button data-testid="confirm-modal-cancel" onClick={() => cancel?.()}>
          {t("general.Cancel")}
        </Button>
        <Button data-testid="confirm-modal-confirm" onClick={() => proceed?.()}>
          {t("general.Confirm")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmModal;
